import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { initRuntimeReporter } from "@plerity/runtime-reporter";

// Force Zod jitless under strict CSP — Zod v4's JIT probes `new Function("")`
// on first parse; the dashboards' CSP blocks it (caught, harmless) but the
// browser fires a securitypolicyviolation that floods the RUM pipeline
// (~2,800 `CSP: script-src blocked eval` occurrences as of 2026-07-15).
// Mirrors @plerity/contracts src/zod-config.ts (separate zod instance).
import { z as _zodCspConfig } from "zod";

_zodCspConfig.config({ jitless: true });

// Phase 7: production runtime-error reporter — captures window.error +
// unhandledrejection and POSTs to /api/observability/errors.
// Disabled in dev (the test-time helper handles E2E specs).
initRuntimeReporter({
  app: "reports",
  disabled: import.meta.env.MODE !== "production",
  buildSha: import.meta.env.VITE_BUILD_SHA ?? "dev",
});

const rootEl = document.getElementById("root");
if (rootEl)
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
